'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.failureFetchBanners = exports.receiveBannerData = exports.deleteBannerImage = exports.postBannerImages = exports.fetchBannerImages = exports.FAILURE_FETCH_BANNERS = exports.RECEIVE_BANNER_DATA = exports.failureCounts = exports.receiveHomeData = exports.fetchDashBoardData = exports.FAILURE_COUNTS = exports.RECEIVE_HOME_DATA = undefined;

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECEIVE_HOME_DATA = exports.RECEIVE_HOME_DATA = 'RECEIVE_HOME_DATA'; /**
                                                                          * Created by zyy on 2018/4/27.
                                                                          */
var FAILURE_COUNTS = exports.FAILURE_COUNTS = 'FAILURE_COUNTS';

var fetchDashBoardData = exports.fetchDashBoardData = function fetchDashBoardData() {
  return function (dispatch) {
    return (0, _api.fetchHomeData)().then(function (response) {
      dispatch(receiveHomeData(response.data));
    }).catch(function (error) {

      dispatch(failureCounts(error));
    });
  };
};

var receiveHomeData = exports.receiveHomeData = function receiveHomeData(data) {
  return {
    type: RECEIVE_HOME_DATA,
    orderCount: data
  };
};

var failureCounts = exports.failureCounts = function failureCounts(err) {
  return {
    type: FAILURE_COUNTS,
    error: err
  };
};
//banner图管理

var RECEIVE_BANNER_DATA = exports.RECEIVE_BANNER_DATA = 'RECEIVE_BANNER_DATA';
var FAILURE_FETCH_BANNERS = exports.FAILURE_FETCH_BANNERS = 'FAILURE_FETCH_BANNERS';

var fetchBannerImages = exports.fetchBannerImages = function fetchBannerImages() {
  return function (dispatch) {
    return (0, _api.fetchBannerData)().then(function (response) {
      dispatch(receiveBannerData(response.data.data));
    }).catch(function (error) {
      _message2.default.error(error.message);
      dispatch(failureFetchBanners(error));
    });
  };
};

var postBannerImages = exports.postBannerImages = function postBannerImages(values) {
  return function (dispatch) {
    return (0, _api.updateBannerData)(values).then(function (response) {
      _message2.default.success('保存成功');
      dispatch(fetchBannerImages());
    }).catch(function (error) {
      _message2.default.error(error.message);
      dispatch(failureFetchBanners(error));
    });
  };
};
var deleteBannerImage = exports.deleteBannerImage = function deleteBannerImage(id) {
  return function (dispatch) {
    return (0, _api.deleteBannerData)(id).then(function (response) {
      _message2.default.success('删除成功');
      dispatch(fetchBannerImages());
    }).catch(function (error) {
      _message2.default.error(error.message);
      dispatch(failureFetchBanners(error));
    });
  };
};

var receiveBannerData = exports.receiveBannerData = function receiveBannerData(data) {
  return {
    type: RECEIVE_BANNER_DATA,
    banners: data
  };
};

var failureFetchBanners = exports.failureFetchBanners = function failureFetchBanners(err) {
  return {
    type: FAILURE_FETCH_BANNERS,
    error: err
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/home.js
// module id = 914
// module chunks = 0